
'use strict';
import {Injectable} from 'ng-metadata/core';
import {DateUtils} from "../../nddUtils/dateUtils.service";
const filter = require('lodash/filter');
const flatten = require('lodash/flatten');
const get = require('lodash/get');

export const MANUAL_DESCRIPTION = 'manualDescription';
export const PERSONAL_DELIVERY = 'personalDelivery';
// Accessibility: autocomplete attribute map for input fields.
export const autocompleteTypeMap = {
    "address_1" : "address-line1",
    "city" : "address-level2",
    "state" : "address-level1",
    "zip" : "postal-code",
    "telephone_1" : "tel",
    "my_email" : "email",
    "old_password" : "current-password",
    "new_password" : "new-password",
}

@Injectable()
export class FormBuilderService {
    
    constructor(private dateUtils: DateUtils) {
    }

    /* getter / setter */
    get formMode() {
        return FormBuilderEnums.FORM_MODE;
    }

    get fieldType() {
        return FormBuilderEnums.FIELD_TYPE;
    }

    get uiType() {
        return FormBuilderEnums.UI_TYPE;
    }

    // Adds the autocomplete types to the fields.
    private addAutocomplete(fields){
        for (let i = 0; i < fields.length; i++) {
            let curField = fields[i];
            let currAutoComplete = autocompleteTypeMap[curField.key];
            curField.autoComplete = (currAutoComplete) ? currAutoComplete : "off";
        }
    }

    public groupFields(fields) {
        this.addAutocomplete(fields);
        let grouped = [];                   //main fields array
        let groupedFields = [];    //init sub fields array with first field
        if (fields[0].uiType !== 'hidden') {
            groupedFields.push(fields[0]);
        }
        for (let i=1;i<fields.length;i++) {
            let curField = fields[i];

            if (!curField.group) {
                if (groupedFields.length === 0) {
                    groupedFields.hidden = true;
                }
                grouped.push(groupedFields);    //push exists sub fields array to main array
                groupedFields  = [];            //init sub fields array
            }

            if (curField.uiType !== 'hidden') {
                groupedFields.push(curField);
            }


        }

        if (groupedFields.length === 0) {
           groupedFields.hidden = true;
        }
        grouped.push(groupedFields);        //push last sub fields array

        return grouped;
    }

    public handleValue(field) {
        if (!field) {
            return;
        }

        let value = field.value;
        if (value && field.fieldType === this.fieldType.DATE) {
          field.value = this.dateUtils.convertIlsDateStringToPrimoDateString(value);
        }
    }

    public validate(form,fields) :IValidationMsg{
        let errorMessages = [];
        //iterate over fields and run validate function for each one
        for(let key in fields) {
            if (fields[key].validator) {
                let validator = fields[key].validator.func;
                let params = fields[key].validator.params;
                if (!validator(form,fields[key].name,params)) {
                    errorMessages.push(fields[key].validator.message);
                }
            }
        }

        return {isOk: errorMessages.length===0, errorMessages: errorMessages};
    }

    public compareFields(form,cur,other) {
        return form[cur] === form[other];
    }

    public getFieldByName(form, name) {
        let matchedFields = filter(flatten(form), (el) => { return el.name === name; });
        if (matchedFields) {
            return matchedFields[0];
        }
    }

    public static getFormatOption(form, format): boolean {
        const formFormat = form.filter(field=>{return field.key=='format'});
        if (Array.isArray(get(formFormat, '[0].options'))) {
            if (formFormat[0].options.filter(field => {return field.value === format}).length > 0) {
                return true;
            }
        }
        return false;
    }
}

export interface IValidationMsg {
	isOk			:boolean;
	errorMessages	:string[];
}

export class FormBuilderEnums{

    private static _formMode = {
        NEW     : 'New',
        EDIT    : 'Edit',
        VIEW    : 'View',
        ERROR   : 'Error'
    };

    private static _fieldType = {
        STRING  : 'string',
        DATE    : 'date',
        BOOLEAN : 'boolean',
        INTERNAL: 'internal'
    };

    private static _uiType = {
        TEXT        : 'text',
        CHECK_BOX   : 'checkbox',
        READ_ONLY   : 'readonly',
        PASSWORD    : 'password',
        DROP_DOWN   : 'dropdown',
        DROP_DOWN_WITH_FILTER_SEARCH    : 'dropdownWithFilterSearch',
        DROP_DOWN_MULTIPLE   : 'comboboxmultiplenew',
        TEXT_AREA   : 'textarea',
        RADIO_BUTTON: 'radio',
        DATE        : 'date',
        LABEL       : 'label',
        MULTI_LABEL : 'multiLabel',
        HIDDEN      : 'hidden',
        LINK : 'link',
        DATE_TIME      : 'datetime',
        DATE_AND_HOURS  :   'dateAndHours',
        DATE_AND_TIME      : 'dateAndTime',
        DATE_DROPDOWN : 'dateDropdown',
        DATE_NOT_NEEDED_AFTER : 'dateNgrs',
        BUTTON_AND_TEXT  :   'buttonAndText',
        INTERACTABLE_LABEL : 'interactableLabel'
    };

    private static _behavior = {
        DISABLED : 'disabled',
        HIDDEN : 'hidden',
        VISIBLE_DISABLED : 'visible_disabled',
    }

    static get FORM_MODE() {
        return this._formMode;
    }

    static get FIELD_TYPE() {
        return this._fieldType;
    }

    static get UI_TYPE() {
        return this._uiType;
    }

    static get BEHAVIOR() {
        return this._behavior;
    }

    static get ROOT() {
        return '$root$';
    }

    static get FIRST() {
        return '$first$';
    }

    static get FIRST_ONLY_IF_DEFAULT_VALUE_PATH_EXIST() {
        return '$firstOnlyIfDefaultValuePathExist$';
    }

    static get FIELD() {
        return '$field$';
    }

    static get TODAY() {
        return '$today$';
    }

    static get FUTURE_DATES() {
        return '$future$';
    }
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/formBuilder/formBuilder.service.ts